/**
 * Copyright 2018 Samsung Electronics All Rights Reserved
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ResponseTransformer } from 'frest';

/**
 * Response data transformer specific for SBaaS use.
 *
 * @remarks
 * This will lowercase JSON response before parsing it. User can
 * opt-out by specifying `noLowerCaseJSON` option in preset so
 * http client will use default JSON transformer which doesn't lowercase
 * JSON key.
 *
 * @param raw Raw response from `fetch` API.
 *
 * @returns Promise which will resolve to transformed
 */
export const sbaasResponseTransformer: ResponseTransformer = raw => {
  const ct = raw.headers.get('Content-Type');
  if (ct && ct.indexOf('application/json') >= 0) {
    return raw
      .clone()
      .text()
      .then(text => {
        // SBaaS internal db querying library make all fields
        // uppercase, so we make all of it lowercase here.
        if (raw.url.indexOf('/api/login') < 0) {
          text = text.replace(
            /"([^"]+)":/g,
            (_: any, $1: any) => '"' + $1.toLowerCase() + '":',
          );
        }
        return JSON.parse(text);
      })
      .catch(err => {
        process.env.NODE_ENV === 'development'
          ? // tslint:disable-next-line:no-console
            console.error('Failed to parse JSON response', err)
          : // tslint:disable-next-line:no-unused-expression
            void 0;
        return raw.body;
      });
  }
  return raw.body;
};
